import type { FeatureFlag } from "~/lib/features";
import { useAuth } from "./useAuth";

export type { FeatureFlag } from "~/lib/features";

export function useFeatureFlag(flag: FeatureFlag): boolean {
  const { features } = useAuth();
  return features[flag] === true;
}
